<template>
    <div class="m-4">
        <h5>{{$t('contact_email_alert')}}</h5>
        <table class="table table-responsive-sm table-striped">
            <thead>
            <tr>
                <td>{{$t('name')}}</td>
                <td>Email</td>
                <td></td>
            </tr>
            </thead>
            <tbody>
            <tr v-for="contact in contacts" :key="contact.id">
                <td><input class=" form-control-sm input-nvx" v-model="contact.name"></td>
                <td><input class="form-control-sm input-nvx" v-model="contact.email"></td>
                <td>
                    <div class="btn-group">
                        <button class="btn btn-sm btn-primary"
                                v-on:click="save(contact)">{{$t('Save')}}
                        </button>
                        <button class="btn btn-sm btn-danger" v-on:click="will_delete(contact)">
                            {{$t('delete')}}
                        </button>
                    </div>
                </td>

            </tr>
            <tr>
                <td><input class="form-control-sm input-nvx" :placeholder="$t('enter_name')"
                           v-model="new_contact.name"></td>
                <td><input class="form-control-sm input-nvx" :placeholder="$t('enter_email')"
                           v-model="new_contact.email"></td>
                <td>
                    <button class="btn btn-sm btn-primary" v-on:click="add(new_contact)">{{$t('add')}}</button>
                </td>
            </tr>
            </tbody>
        </table>

        <div v-if="contact_to_delete">
            <transition name="modal">
                <div class="modal-mask">
                    <div class="modal-wrapper">
                        <div class="modal-dialog" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h4 class="modal-title">{{$t('delete_contact')}}
                                        <span v-if="contact_to_delete" v-text="contact_to_delete.name"></span>
                                    </h4>
                                </div>
                                <div class="modal-body">
                                    <h5>{{$t('delete_contact_definitive')}}</h5>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-default" v-on:click="cancel_delete">{{$t('cancel')}}</button>
                                    <a id='delete-btn' v-on:click="on_delete(contact_to_delete)" class="btn btn-danger">{{$t('delete')}}</a>
                                </div>
                            </div><!-- /.modal-content -->
                        </div><!-- /.modal-dialog -->
                    </div><!-- /.modal -->
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
    import {HTTP} from '../http-constants'

    export default {
        data() {
            return {
                contacts: [],
                new_contact: {},
                contact_to_delete: null
            }
        },
        methods: {
            'load': function () {
                var self = this;
                HTTP.get('/alertcontacts/',)
                    .then(function (re) {
                        self.contacts = re.data;
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            'save': function (contact) {
                HTTP.patch("/alertcontacts/" + contact.id + "/", contact)
                    .then(function (re) {
                        contact = re.data;
                    })
                    .catch(function (error) {
                        console.log(error);
                    })
            },
            'on_delete': function (contact) {
                var self = this;
                this.contact_to_delete = null
                HTTP.delete("/alertcontacts/" + contact.id + "/", contact)
                    .then(function (re) {
                        var idx = self.contacts.indexOf(contact)
                        if (idx >= 0) {
                            self.contacts.splice(idx, 1);
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    })
            },
            'add': function (contact) {
                var self = this;
                if (contact.email == null) {
                    return;
                }
                HTTP.post("/alertcontacts/", contact)
                    .then(function (re) {
                        contact = re.data;
                        self.contacts.push(Object.assign({}, contact));
                        self.new_contact = {}
                    })
                    .catch(function (error) {
                        console.log(error);
                    })
            },
            'will_delete': function (contact) {
                this.contact_to_delete = contact;
            },
            'cancel_delete': function(){
                this.contact_to_delete = null
            }
        },
        mounted: function () {
            this.load();
        }
    }
</script>